import request from '@/http/request'
import {
  addNotice,
  updateNoticeById, 
  delNotice,
  issueNotice,
  getTenantSmsConfig,
  getNotice
} from '@/http/api'

export const getNoticeApi = (data) => {
  return request({
    url: getNotice,
    data
  })
}

export const isgetTenantSmsConfig = (data) => {
  return request({
    url: getTenantSmsConfig,
    data
  })
}

export const addNoticeFn = (data) => {
  return request({
    url: addNotice,
    data
  })
}

export const editNoticeFn = (data) => {
  return request({
    url: updateNoticeById,
    data
  })
}

export const delNoticeFn = (data) => {
  return request({
    url: delNotice,
    data
  })
}

export const issueNoticeFn = (data) => {
  return request({
    url: issueNotice,
    data
  })
}